import React from 'react'

export const AboutCompanyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M10 8.33594H10.0083' stroke='#0F172A' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M10 11.6641H10.0083' stroke='#0F172A' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M10 5H10.0083' stroke='#0F172A' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M13.3359 8.33594H13.3443'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.3359 11.6641H13.3443'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M13.3359 5H13.3443' stroke='#0F172A' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M6.66406 8.33594H6.6724'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.66406 11.6641H6.6724'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M6.66406 5H6.6724' stroke='#0F172A' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M7.5 18.3333V15.8333C7.5 15.6123 7.5878 15.4004 7.74408 15.2441C7.90036 15.0878 8.11232 15 8.33333 15H11.6667C11.8877 15 12.0996 15.0878 12.2559 15.2441C12.4122 15.4004 12.5 15.6123 12.5 15.8333V18.3333'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.0026 1.66406H5.0026C4.08213 1.66406 3.33594 2.41025 3.33594 3.33073V16.6641C3.33594 17.5845 4.08213 18.3307 5.0026 18.3307H15.0026C15.9231 18.3307 16.6693 17.5845 16.6693 16.6641V3.33073C16.6693 2.41025 15.9231 1.66406 15.0026 1.66406Z'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const AboutGlobalResellersIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.9974 18.3307C14.5998 18.3307 18.3307 14.5998 18.3307 9.9974C18.3307 5.39502 14.5998 1.66406 9.9974 1.66406C5.39502 1.66406 1.66406 5.39502 1.66406 9.9974C1.66406 14.5998 5.39502 18.3307 9.9974 18.3307Z'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.9974 1.66406C7.85759 3.91086 6.66406 6.89468 6.66406 9.9974C6.66406 13.1001 7.85759 16.0839 9.9974 18.3307C12.1372 16.0839 13.3307 13.1001 13.3307 9.9974C13.3307 6.89468 12.1372 3.91086 9.9974 1.66406Z'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M1.66406 10H18.3307' stroke='#0F172A' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const AboutPartnersIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.16406 14.1693L10.8307 15.8359C10.9949 16.0001 11.1898 16.1303 11.4042 16.2191C11.6187 16.308 11.8486 16.3537 12.0807 16.3537C12.3129 16.3537 12.5427 16.308 12.7572 16.2191C12.9717 16.1303 13.1666 16.0001 13.3307 15.8359C13.4949 15.6718 13.6251 15.4769 13.7139 15.2624C13.8028 15.048 13.8485 14.8181 13.8485 14.5859C13.8485 14.3538 13.8028 14.1239 13.7139 13.9094C13.6251 13.695 13.4949 13.5001 13.3307 13.3359'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.6688 11.6671L13.7521 13.7504C14.0837 14.0819 14.5333 14.2682 15.0021 14.2682C15.471 14.2682 15.9206 14.0819 16.2521 13.7504C16.5837 13.4189 16.7699 12.9693 16.7699 12.5004C16.7699 12.0316 16.5837 11.5819 16.2521 11.2504L13.0188 8.01709C12.5501 7.54892 11.9146 7.28595 11.2521 7.28595C10.5896 7.28595 9.95423 7.54892 9.48548 8.01709L8.75214 8.75042C8.42062 9.08194 7.97098 9.26819 7.50214 9.26819C7.0333 9.26819 6.58366 9.08194 6.25214 8.75042C5.92062 8.4189 5.73438 7.96926 5.73438 7.50042C5.73438 7.03158 5.92062 6.58194 6.25214 6.25042L8.59381 3.90875C9.35401 3.15054 10.3454 2.66755 11.411 2.53623C12.4766 2.40491 13.5556 2.63278 14.4771 3.18375L14.8688 3.41709C15.2236 3.63124 15.6455 3.70552 16.0521 3.62542L17.5021 3.33375'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.4974 2.5L18.3307 11.6667H16.6641'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.4974 2.5L1.66406 11.6667L7.08073 17.0833C7.41225 17.4149 7.86189 17.6011 8.33073 17.6011C8.79957 17.6011 9.24921 17.4149 9.58073 17.0833C9.91225 16.7518 10.0985 16.3022 10.0985 15.8333C10.0985 15.3645 9.91225 14.9149 9.58073 14.5833'
      stroke='#0F172A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M2.5 3.33594H9.16667' stroke='#0F172A' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
